import { Controller } from '@hotwired/stimulus'

/**
 * Alert Dismissal Controller
 *
 * Handles dismissal of alerts using localStorage so they don't reappear
 * By default alerts are hidden and should be shown
 *
 * Usage:
 * <div class="fade d-none" data-controller="alert-dismissal" data-alert-dismissal-alert-id-value="unique-alert-id">
 *   <button data-action="click->alert-dismissal#dismiss">Close</button>
 * </div>
 */
export default class extends Controller {
    static values = {
        alertId: String,
    }

    connect() {
        // Show alert only if it hasn't been dismissed before
        if (!this.isAlertDismissed()) {
            this.showAlert()
        }
    }

    dismiss() {
        // Store dismissal in localStorage
        this.markAlertDismissed()
        this.hideAlert()
    }

    isAlertDismissed() {
        const stored = localStorage.getItem('dismissed-alerts')
        const dismissedAlerts = stored ? JSON.parse(stored) : []
        return dismissedAlerts.includes(this.alertIdValue)
    }

    markAlertDismissed() {
        const stored = localStorage.getItem('dismissed-alerts')
        const dismissedAlerts = stored ? JSON.parse(stored) : []
        if (!dismissedAlerts.includes(this.alertIdValue)) {
            dismissedAlerts.push(this.alertIdValue)
            localStorage.setItem('dismissed-alerts', JSON.stringify(dismissedAlerts))
        }
    }

    showAlert() {
        this.element.classList.remove('d-none')
        this.element.classList.add('d-block')
        this.element.classList.add('show') // Add 'show' class to trigger fade-in
    }

    hideAlert() {
        this.element.remove()
    }
}
